<template>
    <PatchNoteForm></PatchNoteForm>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PatchNoteForm = defineAsyncComponent(() =>
    import("../../components/PatchNotes/PatchNoteForm.vue")
);

export default {
    name: "PatchNotes_CreateForm", //The name you are in should not equal the name of the component you are importing.
    components: { PatchNoteForm, AuthLayout },
};
</script>
